import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicNotSetupAcademicYear({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-10.9%"
          y="-7.8%"
          width="121.9%"
          height="121.9%"
          filterUnits="objectBoundingBox"
          id="pic-not-setup-academic-year_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <circle id="pic-not-setup-academic-year_svg__b" cx={32} cy={32} r={32} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M168.28 136c-43.35 0-57.18 12-92.2 12C46 148 6.41 139.34 15 97.94 23.03 59.21 55.23 47.5 90.85 21c108.23-80.52 198.12 115 77.43 115z"
          fill="#FFE6CE"
        />
        <path
          d="M168.28 136c-44.2-1.04-46.37 12-97.86 11-29.64 0-54.86-9.88-56.61-36-.81-34.35 65.4-7.86 92.65-23.52 56.38-32.42 112.99 28.47 103.33 36.35-9.66 7.88-24.98 12.56-41.5 12.17z"
          fill="#FB8F23"
          opacity={0.16}
        />
        <path
          d="M171.6 107.42a8 8 0 11-4.14 15.46 8 8 0 014.14-15.46zm12.94-48.3A8 8 0 01190 69.6l-8.66 27.35h-.03a6.67 6.67 0 11-12.72-3.98l6-27.44c.04-.25.1-.5.16-.75a8 8 0 019.8-5.66z"
          fill="#FCC083"
        />
        <g transform="translate(59 41)">
          <path
            d="M68.44 53.57L4.15 30.3a1.8 1.8 0 01-.13-3.33L62.61.34a1.8 1.8 0 011.5 0l30.35 14 1.12.52 26.62 12.27a1.8 1.8 0 01-.03 3.28L69.78 53.53c-.42.19-.9.2-1.34.04z"
            fill="#666"
          />
          <path
            d="M36.76 54.22l-3.91 5.5s1.3 5.66 30.11 5.51c28.81-.15 31.09-5.5 31.09-5.5l-5.37-7.34-16.44-10.56-35.48 12.4z"
            fill="#333532"
          />
          <path fill="#666" d="M118.55 59.5l-2.55.08-2.85-27 2.63.68z" />
          <circle fill="#666" cx={117.9} cy={61.2} r={3.6} />
          <path
            d="M37.4 32.17l-4.55 27.66s32.72-10.57 61.2 0l-4.23-29.28s-31.9-12.07-52.41 1.62z"
            fill="#595858"
          />
        </g>
        <g transform="translate(42 100)">
          <use
            fill="#000"
            filter="url(#pic-not-setup-academic-year_svg__a)"
            xlinkHref="#pic-not-setup-academic-year_svg__b"
          />
          <circle fill="#FFF" cx={32} cy={32} r={32} />
        </g>
        <g fill="#FB8F23">
          <path d="M90.71 121.45l-4 4.03-3.92-.71-.7-3.91 4-4.03a4.39 4.39 0 00-3.13-1.26c-.96.05-3 .59-4.6 2.27-1.53 1.62-3.14 4.64-1.71 7.99.17.4.36.93-.2 1.5-.58.57-17.2 16.34-17.2 16.34-1.38 1.19-1.28 3.38-.01 4.66 1.3 1.27 3.47 1.35 4.66-.02 0 0 15.65-16.55 16.32-17.21.6-.6 1.15-.4 1.5-.2 2.54 1.3 6.14.16 8-1.7a7.08 7.08 0 002.27-4.6 4.15 4.15 0 00-1.28-3.15zm-28.24 25.26c-.45.44-1.18.44-1.62 0a1.15 1.15 0 010-1.62 1.15 1.15 0 011.62 0c.44.45.44 1.18 0 1.62z" />
          <path d="M72.24 129.47l-2.54 2.46-5.3-5.27-1.27 1.23-7.13-6.9 5.09-4.93 7.12 6.9-1.27 1.23 5.3 5.28zM88.7 146.8l-2.04 1.98a3.68 3.68 0 01-5.09 0s-8.15-8.25-8.03-7.96c3-5.06 7.36-6.2 7.36-6.2l7.8 7.26a3.4 3.4 0 010 4.92zm-12.1-6.96a.86.86 0 000 1.24l6.54 6.34c.35.34.92.34 1.28 0a.86.86 0 000-1.24l-6.55-6.34a.92.92 0 00-1.27 0zm10.7 3.55l-6.55-6.34a.92.92 0 00-1.28 0 .85.85 0 000 1.24l6.55 6.34c.35.34.92.34 1.27 0a.86.86 0 000-1.24z" />
        </g>
      </g>
    </svg>
  );
}

SvgPicNotSetupAcademicYear.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicNotSetupAcademicYear.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicNotSetupAcademicYear svgRef={ref} {...props} />
));
export default ForwardRef;
